import {Grid} from "@mui/material";
import Pasos_Contactos from "./SubComponentes/Pasos_Contactos";
import Formulario_Contactenos from "./SubComponentes/Formulario_Contactenos";

const Progamar_Consulta = () => {
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{pt:13}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 10}}
                sx={{ px:3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 6}}>
                    <Pasos_Contactos/>
                </Grid>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 6}}>
                    <Formulario_Contactenos/>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default Progamar_Consulta;

